/* eslint-disable no-unused-vars */
import React from 'react';
import { Avatar, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';
import useStore from '../../states/store';

export default function UserInfo() {
  const auth = useStore((state) => state.auth);
  const name =
    auth.designation !== 'temp_admin' ? `${auth?.first_name} ${auth?.last_name}` : 'USER';
  return (
    <>
      <Avatar sx={{ mb: 2 }}>
        <Person />
      </Avatar>

      <Typography variant='h7'>{name}</Typography>
      {auth.designation !== 'temp_admin' ? (
        <Typography variant='subtitle1'>
          {auth?.designation === 'sub_admin' ? 'Sub-Admin' : auth?.designation}
        </Typography>
      ) : (
        ''
      )}
    </>
  );
}
